import { SchoolDays } from './school-days.model';

export class OrganizationSchoolDays extends SchoolDays {
  organizationId: number = 0;
  constructor(data?) {
    super(data);
    if(data) this.organizationId = data.organizationId;
  }
}